<template>
	<div>
		<calendar-view
			:show-date="showDate"
			:items="events"
			:showTimes="true"
			:timeFormatOptions="{ hour: 'numeric', minute: 'numeric' }"
			class="booking theme-default"
		>
			<template #header="{ headerProps }">
				<calendar-view-header
					:header-props="headerProps"
					@input="setShowDate"
				/>
			</template>
		</calendar-view>
	</div>
</template>

<script>
import Vue from "vue/dist/vue.js";
import VueResource from "vue-resource";
import { CalendarView, CalendarViewHeader } from "vue-simple-calendar";

Vue.use(VueResource);
export default {
	props: ["rink", "selected"],
	name: "app",
	data: function () {
		return {
			events: [],
			showDate: this.selected,
		};
	},
	components: {
		CalendarView,
		CalendarViewHeader,
	},
	mounted: function () {
		const bookingMonth = localStorage.getItem('bookingMonth');
		if (bookingMonth) {
			this.showDate = new Date(bookingMonth);
		}
	},
	watch: {
      	selected: function(newVal, oldVal) { // watch it
          this.showDate = newVal;
        }
    },
	methods: {
		setShowDate(date) {
			localStorage.setItem('bookingMonth', date);
			this.$emit('date', date);
			this.showDate = date;
		},
		getUrl: function (type) {
			return "/api/bookings.json?rink=" + this.rink;
		},
		getFormattedDate: function(date) {
    		return date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear()
		}
	},
	created: function () {
		let url = this.getUrl();
		this.$http.get(url).then(function (response) {
			this.events = response.body.data;
		});
	},
};
</script>
